<template>
  <v-layout>
    <MainMenu />
    <v-layout column>
      <v-layout>
        <v-flex>
          <listPagesHeader :page-title="pageTitle" />
          <div class="page-content-paddings">
            <v-layout>
              <FiltersBar
                :filters-values-id="1"
                :page-limit="noVolunteersFamilies.pagination.amount"
              />
            </v-layout>
            <v-layout class="list-header">
              <v-flex
                shrink
                :class="{ xs12: xsOnly }"
                class="d-layout"
              >
                <h2 class="d-inline-block">
                  {{ $t('menu.families') }}
                  <span v-if="!noVolunteersFamilies.isLoading">({{ noVolunteersFamilies.amount }})</span>
                </h2>
              </v-flex>
            </v-layout>
            <v-layout>
              <p class="mt-2 mb-0">
                {{ $t('instructions.unassigned') }}
              </p>
            </v-layout>
            <v-layout
              v-if="hasPermissionForFamilyEditionAdd"
              mt-3
            >
              <p>
                {{ $t('instructions.unassigned_to_guide') }}
                <a
                  class="small"
                  :href="links.ADD_FAMILY_GUIDE"
                  target="_blank"
                >{{
                  $t('instructions.unassigned_to_guide_link')
                }}</a>
              </p>
            </v-layout>
            <noVolunteerFamiliesTable
              :is-loading="noVolunteersFamilies.isLoading"
              :headers="families.headers"
              :items="noVolunteersFamilies.data"
              @reject="reloadFamilyRecord($event)"
              @accept="removeFamilyRecord($event)"
              @sorting="fetchFamilies"
            />
            <BasePagination
              :pagination="noVolunteersFamilies.pagination"
              :amount-all="amountAll"
              @page="setPage"
              @amount="setItemsPerPage"
            />
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-end>
        <v-flex class="footer-wrap">
          <div class="page-content-paddings">
            <AppFooter class="mb-3" />
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import listPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import AppFooter from '@/components/widgets/AppFooter';

import filters from '@/constants/filters';
import BasePagination from '@/components/widgets/dataTable/BasePagination';
import FiltersBar from '@/components/widgets/dataTable/FiltersBar';
import noVolunteerFamiliesTable from '@/components/widgets/families/noVolunteerFamiliesTable';

import Permissions from '@/constants/permissions';
import links from '@/constants/links';
import search from '@/mixins/search';

export default {
    name: 'PendingFamiliesPage',
    components: {
        noVolunteerFamiliesTable,
        BasePagination,
        MainMenu,
        listPagesHeader,
        FiltersBar,
        AppFooter
    },
    filters: {
        ...filters
    },
    mixins: [search],
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            if (from.name !== 'family-card') {
                vm.$store.commit('search/clearFilter');
            }
            vm.$store.dispatch('auth/permissionGuard', [
                Permissions.FAMILY_EDITION_LIST_VIEW,
                Permissions.ASSIGNED_FAMILY_EDITION_LIST_VIEW
            ]);
        });
    },
    beforeRouteLeave (to, from, next) {
        if (to.name !== 'family-card') {
            this.$store.commit('search/clearFilter');
        }
        next();
    },
    data () {
        return {
            Permissions,
            links,
            selected: [],
            filterDialog: false,
            families: {
                headers: [
                    {
                        text: this.$t('label.family_code'),
                        value: 'family_id',
                        sortable: false,
                        align: 'left',
                        desktopOnly: false
                    },
                    {
                        text: this.$t('label.family'),
                        value: 'last_name',
                        sortable: false,
                        sort: true,
                        desktopOnly: false,
                        icon: 'SortIcon',
                        sortingType: 1
                    },
                    {
                        text: this.$t('label.address'),
                        value: 'address',
                        sortable: false,
                        sort: true,
                        desktopOnly: true,
                        icon: 'SortIcon',
                        sortingType: 1
                    },
                    { text: this.$t('label.volunteers'), value: '', sortable: false, desktopOnly: true },
                    { text: this.$t('label.status'), value: '', sortable: false, desktopOnly: false },
                    { text: this.$t('label.manage'), value: '', sortable: false, desktopOnly: true }
                ],
                pagination: { page: 1, amount: 20, amountAll: 0 },
                receivedDataAmount: '',
                receivedData: [],
                isLoading: true
            },
            hasPermissionForFamilyEditionView: null,
            hasPermissionForFamilyEditionAdd: null
        };
    },
    computed: {
        desktopOnly () {
            return this.$vuetify.breakpoint.smAndUp;
        },
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        pageTitle () {
            return this.$t('menu.families_to_accept');
        },
        noVolunteersFamilies () {
            return this.$store.getters['familyData/getNoVolunteersFamilies'];
        },
        amountAll () {
            return this.noVolunteersFamilies.amount ? this.noVolunteersFamilies.amount : 0;
        },
        filterPermission () {
            return this.$store.getters['auth/getPermissions'].includes(this.Permissions.USE_SEARCH_ENGINE);
        },
        filter () {
            return this.$store.getters['search/getFilter'];
        }
    },
    created () {
        this.$store.dispatch('auth/hasPermission', this.Permissions.FAMILY_EDITION_VIEW).then((res) => {
            this.hasPermissionForFamilyEditionView = res;
        });
        this.$store.dispatch('auth/hasPermission', this.Permissions.FAMILY_EDITION_ADD).then((res) => {
            this.hasPermissionForFamilyEditionAdd = res;
        });
    },
    methods: {
        setPage (event) {
            this.$store.commit('familyData/setNoVolunteersPagination', {
                page: event
            });
            this.fetchFamilies();
        },
        setItemsPerPage (event) {
            this.$store.commit('familyData/setNoVolunteersPagination', {
                amount: event,
                page: 1
            });
            this.fetchFamilies();
        },
        fetchFamilies () {
            const filters = this.getFiltersWithValue();
            this.$store.dispatch('familyData/getNoVolunteersFamilies', filters);
        },
        reloadFamilyRecord (event) {
            if (this.hasPermissionForFamilyEditionView) {
                this.$store
                    .dispatch('family/getFamily', { id: event, endpointLabel: 'family' })
                    .then(() => {
                        this.$store.dispatch(
                            'familyData/changeFamilyDataInList',
                            this.$store.getters['family/getFamily']
                        );
                    });
            } else {
                this.removeFamilyRecord(event);
            }
        },
        removeFamilyRecord (event) {
            this.$store.dispatch('familyData/removeFamilyRecord', event);
        }
    }
};
</script>

<style lang="scss" scoped></style>
